import { Injectable } from '@angular/core';

import { ImportExportControllerService } from '@osos/shared/api';
import { ImportResultModel } from '@osos/shared/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ExportDataService extends ImportExportControllerService {
  exportEntityDetails({ entityId }): Observable<Blob> {
    return this.exportDataEntities({
      body: {
        dataEntities: [
          {
            id: entityId,
          },
        ],
      },
    });
  }

  exportModuleDetails({
    moduleId,
    entities,
  }: {
    moduleId: string;
    entities: string[];
  }): Observable<Blob> {
    return this.exportDataModel({
      body: {
        dataModules: [
          {
            id: moduleId,
            dataEntities: entities.map((entity) => ({ id: entity })),
          },
        ],
      },
    });
  }

  validateImportedFile({
    fileId,
    moduleId,
  }: {
    fileId: string;
    moduleId?: string;
  }): Observable<ImportResultModel> {
    return this.validateFileToImport({
      fileId,
      body: {
        moduleId,
      },
    }).pipe(map((res) => res as ImportResultModel));
  }

  confirmImportedFile({
    fileId,
    moduleId,
  }: {
    fileId: string;
    moduleId?: string;
  }) {
    return this.confirmFileImport({
      fileId,
      body: {
        moduleId,
      },
    });
  }
}
